import { Container } from 'react-bootstrap';
import '../index.scss';

const Tasks = () => {
  return (
    <div className="prmPage" data-testid="prm-tasks-page">
      <Container>
        <h1 className="Heading Heading--h5">Tasks</h1>
        <p className="Preamble">Tasks will be available here soon.</p>
      </Container>
    </div>
  );
};

export default Tasks;
